import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import { columTypeList } from '../../Components/helper';

const style = {
  cursor: 'move',
};

function MovingColumnCards({
  id,
  isProductArchived,
  ColumnItem,
  onSelectCheckBox,
  editState,
  handleEdit,
  activeInactiveClicked,
  deleteColumn,
  index,
  moveColumn,
  isName,
}) {
  const ref = useRef(null);
  const { t } = useTranslation('common');

  const {
    Users: { logInRights },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');
  const OperationalDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'delete');

  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveColumn(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));

  return (
    <tr key={`column_${id}_${index}`} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      {!isSupplierLoggedIn && (OperationalAddEditAccess || OperationalDeleteAccess) && (
        <td>
          <div className="checkbox-label no-label margin-auto">
            <input
              onChange={(e) => {
                onSelectCheckBox(e, ColumnItem?._id);
              }}
              name={`checks_${ColumnItem?._id}`}
              id={`checks_${ColumnItem?._id}`}
              type="checkbox"
              checked={editState?.selectedColumns?.includes(ColumnItem?._id)}
            />
            <label htmlFor={`checks_${ColumnItem?._id}`} className="chklabel" />
          </div>
        </td>
      )}
      <td style={{ wordBreak: 'break-word' }}>{ColumnItem?.name}</td>
      <td>
        {columTypeList?.find((element) => element?._id === ColumnItem?.columnType)?.name === 'Source'
          ? columTypeList?.find((element) => element?._id === ColumnItem?.columnType)?.name
          : `${columTypeList?.find((element) => element?._id === ColumnItem?.columnType)?.name} (${ColumnItem?.manualType?.type})`}
      </td>
      {!isSupplierLoggedIn && (OperationalAddEditAccess || OperationalDeleteAccess) && (
        <td>
          {OperationalAddEditAccess && (
            <button title={t('OPERATIONAL_CP.MOVING_CARD.EDIT')} className="btn px-1" onClick={() => handleEdit(index)} disabled={isProductArchived}>
              <span className="icon-edit" />
            </button>
          )}
          {OperationalAddEditAccess && (
            <button className="btn px-1 mr-0" id={ColumnItem?._id} disabled={isProductArchived}>
              <span className="icon-expand" />
            </button>
          )}
          {OperationalAddEditAccess && (
            <button
              className="btn px-1 mr-0"
              title={ColumnItem.isActive ? t('OPERATIONAL_CP.MOVING_CARD.ACTIVE') : t('OPERATIONAL_CP.MOVING_CARD.INACTIVE')}
              onClick={() => activeInactiveClicked(index)}
              id={ColumnItem._id}
              disabled={isProductArchived}
            >
              <span className={ColumnItem.isActive ? 'icon-active' : 'icon-inactive'} />
            </button>
          )}
          {OperationalDeleteAccess && (
            <button
              className="btn px-1"
              title={t('OPERATIONAL_CP.MOVING_CARD.DELETE')}
              disabled={isProductArchived}
              onClick={() => deleteColumn(ColumnItem?._id)}
            >
              <span className="icon-delete" />
            </button>
          )}
        </td>
      )}
    </tr>
  );
}

export default MovingColumnCards;
